export default function Careers() {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Competitive Compensation',
      description: 'Industry-leading salaries and performance bonuses'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Health & Wellness',
      description: 'Comprehensive medical, dental, and vision coverage'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Learning & Development',
      description: 'Continuous training and career advancement opportunities'
    },
    {
      icon: 'ri-time-line',
      title: 'Work-Life Balance',
      description: 'Flexible schedules and generous paid time off'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Opportunities',
      description: 'International assignments and cross-cultural experiences'
    },
    {
      icon: 'ri-team-line',
      title: 'Collaborative Culture',
      description: 'Inclusive environment that values diverse perspectives'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#00D9C9]/10 rounded-full mb-6">
            <i className="ri-briefcase-line text-[#00D9C9] text-lg"></i>
            <span className="text-[#00D9C9] text-sm font-medium">Join Our Team</span>
          </div>
          <h2 className="text-4xl font-bold text-[#001E3C] mb-4">
            Build Your Career with HI-TAK
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Join a team of passionate professionals dedicated to innovation and excellence in precision manufacturing
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-6 bg-gray-50 rounded-xl hover:bg-[#00D9C9]/5 transition-colors duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#00D9C9]/10 rounded-lg flex-shrink-0">
                <i className={`${benefit.icon} text-[#00D9C9] text-xl`}></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-[#001E3C] mb-1">{benefit.title}</h3>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="relative rounded-2xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/053c6112e50ef53c17b69fcdc7545de1.jpg"
              alt="Join HI-TAK Team"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#001E3C]/90 to-[#001E3C]/70"></div>
          </div>

          <div className="relative z-10 px-8 md:px-16 py-16 md:py-20">
            <div className="max-w-2xl">
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Ready to Make an Impact?
              </h3>
              <p className="text-gray-200 text-lg mb-8">
                Explore current openings and discover how you can contribute to the future of precision manufacturing technology.
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-8 py-4 bg-[#00D9C9] text-white font-semibold rounded-lg hover:bg-[#00C4B8] transition-colors duration-300 whitespace-nowrap cursor-pointer"
                >
                  <span>View Open Positions</span>
                  <i className="ri-arrow-right-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 text-white font-semibold rounded-lg hover:bg-white/20 transition-colors duration-300 backdrop-blur-sm whitespace-nowrap cursor-pointer"
                >
                  <span>Submit Your Resume</span>
                  <i className="ri-file-upload-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
